import { render, staticRenderFns } from "./VAverages.vue?vue&type=template&id=a9882b1c&"
import script from "./VAverages.vue?vue&type=script&lang=js&"
export * from "./VAverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports